import {
  UPDATE_PRODUCT_PRICE_PAGE_NUMBER,
  GET_PRODUCT_PRICE_PENDING,
  GET_PRODUCT_PRICE,
  GET_PRODUCT_PRICE_SELECT,
  DELETE_PRODUCT_PRICE,
  FETCH_PRODUCT_PRICE,
  EDIT_PRODUCT_PRICE,
  ADD_PRODUCT_PRICE,
  CLEAR_PRODUCT_PRICE,
  RESET_PRODUCT_PRICE,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  product_price: [],
  select_list: [],
  pending: false,
  pageNumber: 1,
  deleted: false,
  updated: false,
  created: false,
};

export default function ProductPrice(state = initialState, action) {
  switch (action.type) {
    case GET_PRODUCT_PRICE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case UPDATE_PRODUCT_PRICE_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case GET_PRODUCT_PRICE:
      return {
        ...state,
        product_price: action.payload,
        pending: false,
      };
    case GET_PRODUCT_PRICE_SELECT:
      return {
        ...state,
        select_list: action.payload,
        pending: false,
      };
    case FETCH_PRODUCT_PRICE:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };

    case EDIT_PRODUCT_PRICE:
      return {
        ...state,
        updated: action.payload,
        pending: false
      };

    case DELETE_PRODUCT_PRICE:
      return {
        ...state,
        updated: action.payload,
        pending: false
      };

    case ADD_PRODUCT_PRICE:
      return {
        ...state,
        updated: action.payload,
        pending: false
      };

    case RESET_PRODUCT_PRICE:
      return {
        ...state,
        deleted: false,
        updated: false,
        created: false,
        pending: false
      };

    case CLEAR_PRODUCT_PRICE:
      return {
        ...state,
        ...initialState,
      };

    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
